import gql from "graphql-tag";

export const POC_360_TOKEN_INVITE = gql`
  query tokenQueryPoc360TokensInvite(
    $first: Int
    $offset: Int
    $orderBy: [String]
    $user: ID
    $survey: ID
    $createdBy: ID
    $invited: Boolean
    $valid: Boolean
    $responseSourceFor:ID
    $message_Icontains:String
    $user_FirstName_Icontains:String
    $after:String 
  ) {
    getAllTokensList(
      first: $first
      offset: $offset
      orderBy: $orderBy
      user: $user
      survey: $survey
      createdBy: $createdBy
      invited: $invited
      valid: $valid
      responseSourceFor:$responseSourceFor
      message_Icontains:$message_Icontains
      user_FirstName_Icontains:$user_FirstName_Icontains
      after:$after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node{ 
          id
          link 
          user{
            id
            firstName
            lastName
            email
            employee{
              id
              verticalHeadEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
              verticalMembersEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
            }
          }
          createdBy{
            id
            email
            firstName
            lastName
            employee{
              id
              verticalHeadEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
              verticalMembersEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
            } 
          }
          valid
          respondentType
          responseSourceFor{
            id
          }
        }
      }
    }
  }
`;

export const POC_RESPONSE_FOR_TOKEN = gql`
  query tokenQueryPocResponseForToken(
    $id: ID!
    $first:Int
    $after:String 
  ) {
     responseByResponseId(id:$id){
      id
      multisourceResponseSet(first:$first,after:$after){
       pageInfo{
          hasNextPage
          endCursor
        }
        edges{
          node{
            id
            responseDate
            user{
              id
            }
          }
        }
      }
    }
  }
`;

export const ORG_POC_360_TOKEN_INVITE = gql`
  query org_poc_360_token_invite(
    $orgId: ID!
    $survey: ID
    $valid: Boolean
    $after: String
  ) {
    tokenListByOrgId(orgId: $orgId, survey: $survey, valid: $valid, after: $after) {
      pageInfo {
        hasNextPage,
        endCursor
      }
      totalCount
      edges {
        cursor
        node {
          id
          link
          user {
            id
            firstName
            lastName
            email
          }
          createdBy {
            id
            email
            firstName
            lastName
          }
          valid
          respondentType
          responseSourceFor {
            id
          }
        }
      }
    }
  }
`;
